export default {
  methods: {
    printReport(reportHeader, tableHeaders = '', tableRows = '', styles = '') {
      const style = styles || `<style>
      body { font-family: Arial, sans-serif; }
      table { width: 100%; border-collapse: collapse; margin: 20px 0; font-size: 11px; }
      th, td { border: 1px solid black; padding: 5px; overflow: visible; white-space: normal; word-wrap: break-word; }
      .numCell { text-align: right; padding-right: 5px; }
      .text_rotate { rotate: -90deg; white-space: pre; width: 50px; text-align: center; padding: 0px; }
    </style>`

      const html = `<!DOCTYPE html>
<html>
  <head>${style}</head>
  <body>${reportHeader}
    <table>
      <thead>${tableHeaders}</thead>
      <tbody>${tableRows}</tbody>
    </table>
  </body>
</html>`

      const PrintWin = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
      PrintWin.document.write(html)
      PrintWin.document.close();
      PrintWin.focus();
      PrintWin.print();
      PrintWin.close();
    },

    generateWorkSheetHeader(worksheet, subtitle, approvedHeader = false) {
      // Calculate last column name/index
      const lastColumn = this.getColumnCode(this.getWorksheetColumns.length - 1)
      let rowNumber = 1;

      // If there is header with approvals - add it first
      if (approvedHeader) {
        const newColumns = Array(7).fill('')
        this.getApprovedHeader.forEach((row) => {
          let newRow = worksheet.insertRow(rowNumber, row.toSpliced(2, 0, ...newColumns));
          newRow.font = { bold: true, size: 12 };
          newRow.alignment = this.rowAlignmentWrapped;
          if (rowNumber === 2) newRow.height = 60;  // lineCount * 20
          worksheet.mergeCells(`A${rowNumber}:B${rowNumber}`);
          worksheet.mergeCells(`J${rowNumber}:${lastColumn}${rowNumber}`);
          rowNumber++;
        });
      }

      // Main header
      let titleRow = worksheet.insertRow(rowNumber, [this.$t('reports.reports_title')]);
      titleRow.font = { bold: true, size: 16 };
      titleRow.alignment = this.rowAlignment;
      worksheet.mergeCells(`A${rowNumber}:${lastColumn}${rowNumber}`);
      rowNumber++;

      // Subheaders
      titleRow = worksheet.insertRow(rowNumber, [subtitle]);
      titleRow.font = { size: 14 };
      titleRow.alignment = this.rowAlignment;
      worksheet.mergeCells(`A${rowNumber}:${lastColumn}${rowNumber}`);
      rowNumber++;

      // additional sub headers
      if (this.headerTitles && this.headerTitles.length > 0) {
        titleRow = worksheet.insertRow(rowNumber, [Array.isArray(this.headerTitles) ? this.headerTitles.join(', ') : this.headerTitles]);
        titleRow.font = { size: 14 };
        titleRow.alignment = this.rowAlignment;
        worksheet.mergeCells(`A${rowNumber}:${lastColumn}${rowNumber}`);
      }
    },

    formatHeaderRow(worksheet, rowNo)     {
      // Применение форматирования для строк заголовка
        const headerRow = worksheet.getRow(rowNo);
        headerRow.eachCell({ includeEmpty: true }, (cell) => {
          cell.fill = this.headerCellFill;
        });
        headerRow.font = { bold: true, color: { argb: 'FFFFFFFF' } };
        headerRow.alignment = this.rowAlignment;
      },

    insertAdditionalHeader(worksheet, key, label, rowNo, count) {
      // Вставка дополнительного заголовка
      const columnBefore = this.getWorksheetColumns.findIndex(item => item.key === key)
      const columnsAfter = this.getWorksheetColumns.length - columnBefore - count

      const newColumns = Array(columnBefore).fill('').concat([label], Array(columnsAfter + 1).fill(''));
      worksheet.insertRow(rowNo, newColumns);

      // Объединение ячеек для "coating_type"
      const column1Code = this.getColumnCode(columnBefore)
      const column2Code = this.getColumnCode(columnBefore + count - 1)
      worksheet.mergeCells(`${column1Code}${rowNo}:${column2Code}${rowNo}`);

      this.formatHeaderRow(worksheet, rowNo)
    },

    addSignatureFooterSummaryTitleList(worksheet) {
      // Add empty rows for spacing
      worksheet.addRow([]);
      worksheet.addRow([]);

      // Create signature row
      const signatureRow = worksheet.addRow([]);
      const rowNumber = signatureRow.number;

      signatureRow.height = 61;

      // Column A - First signature
      worksheet.mergeCells(`A${rowNumber}:B${rowNumber}`);
      const cellA = signatureRow.getCell(1);
      cellA.value = `Директор ДДХ при МТиК КР\n______________\n"_____"_______________202${new Date().toLocaleDateString().slice(-1)} г.`;
      cellA.alignment = { vertical: 'top', wrapText: true };
      cellA.font = { bold: true };

      // Merge cells D, E, F for the second signature
      worksheet.mergeCells(`D${rowNumber}:F${rowNumber}`);
      const cellD = signatureRow.getCell(5); // Column F is index 6
      cellD.value = `Зам. директора ДДХ при МТиК КР\n______________\n"_____"_______________202${new Date().toLocaleDateString().slice(-1)} г.`;
      cellD.alignment = { vertical: 'top', horizontal: 'center', wrapText: true };
      cellD.font = { bold: true };

      // Merge cells H, I, J for the third signature
      worksheet.mergeCells(`H${rowNumber}:J${rowNumber}`);
      const cellH = signatureRow.getCell(8);
      cellH.value = `Зам. директора ДДХ при МТиК КР\n______________\n"_____"_______________202${new Date().toLocaleDateString().slice(-1)} г.`;
      cellH.alignment = { vertical: 'top', horizontal: 'center', wrapText: true };
      cellH.font = { bold: true };
    },

    addSignatureFooter(worksheet) {
      // Add empty rows for spacing
      worksheet.addRow([]);
      worksheet.addRow([]);

      // Create signature row
      const signatureRow = worksheet.addRow([]);
      const rowNumber = signatureRow.number;

      // Column B - First signature (no merging needed)
      const cellB = signatureRow.getCell(2);
      cellB.value = `Директор ДДХ при МТиК КР\n______________\n"_____"_______________202${new Date().toLocaleDateString().slice(-1)} г.`;
      cellB.alignment = { vertical: 'top', wrapText: true };
      cellB.font = { bold: true };

      // Merge cells F, G, H for the second signature
      worksheet.mergeCells(`F${rowNumber}:H${rowNumber}`);
      const cellF = signatureRow.getCell(6); // Column F is index 6
      cellF.value = `Зам. директора ДДХ при МТиК КР\n______________\n"_____"_______________202${new Date().toLocaleDateString().slice(-1)} г.`;
      cellF.alignment = { vertical: 'top', horizontal: 'center', wrapText: true };
      cellF.font = { bold: true };

      // Merge cells K, L for the third signature
      worksheet.mergeCells(`K${rowNumber}:L${rowNumber}`);
      const cellK = signatureRow.getCell(11); // Column K is index 11
      cellK.value = `Зам. директора ДДХ при МТиК КР\n______________\n"_____"_______________202${new Date().toLocaleDateString().slice(-1)} г.`;
      cellK.alignment = { vertical: 'top', horizontal: 'center', wrapText: true };
      cellK.font = { bold: true };
    },

    generateWorkSheet(workbook, workbookName, subtitle, reportData, totalData = null, colSpan = null, extraHeader = false) {
      const worksheet = workbook.addWorksheet(workbookName);

      const columns = this.getWorksheetColumns;
      worksheet.columns = columns;

      // Set column formats
      const formatNumber = (digits) => `#,##0${digits ? '.' : ''}${'0'.repeat(digits)}`;
      columns.forEach(col => {
        if (col.num) {
          const isYearField = col.key.toLowerCase().includes('year');
          const digits = col.digits || 0;

          // Use '0' format for year (no comma), otherwise standard
          const format = isYearField ? '0' : formatNumber(digits);
          worksheet.getColumn(col.key).numFmt = format;
        }
      });


      // Add each row
      reportData.forEach(item => {
        const row = {};
        columns.forEach(col => {
          let val = item[col.key];
          if (typeof val === 'number' && col.num && col.digits === 0) {
            val = Math.round(val); // ✅ This rounds the value itself
          }
          row[col.key] = val;
        });
        worksheet.addRow(row);
      });

      // Add totals row if needed
      if (totalData !== null) {
        const emptyCells = colSpan ? Array(colSpan - 1).fill('') : [];
        const totalRow = worksheet.addRow([
          this.$t('label.total'),
          ...emptyCells,
          ...Object.values(totalData)
        ]);
        totalRow.font = { bold: true, size: 12 };
      }

      // Format the header row
      this.formatHeaderRow(worksheet, 1);

      // Add title/subtitle
      this.generateWorkSheetHeader(worksheet, subtitle, extraHeader);

      return worksheet;
    },

    getColumnCode(columnNo) {
      return String.fromCharCode('A'.charCodeAt(0) + columnNo)
    },
  },

  computed: {
    getTableHeaders() {
      const columns = this.getWorksheetColumns.map(col => `<th>${col.header}</th>`).join('')
      return `<tr>${columns}</tr>`
    },

    rowAlignment() {
      return { vertical: 'middle', horizontal: 'center' };
    },

    rowAlignmentWrapped() {
      return { vertical: 'middle', horizontal: 'center', wrapText: true };
    },

    headerCellFill() {
      return { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF0070C0' } }; // Blue
    },

    getApprovedHeader() {
      const placeholders = "_______________";
      const datePlaceholder = `"_____"_________________ 202${new Date().toLocaleDateString().slice(-1)}`;

      return [
        [this.$t('reports.agreed'), '', this.$t('reports.approve')],
        [this.$t('reports.deputy_minister'), '', this.$t('reports.minister')],
        [placeholders, '', placeholders],
        [datePlaceholder, '', datePlaceholder]
      ];
    },
  }
}
